<template>
    <div class="theHeader">
        <div id="allmap"
             style="width:0px;heigth:0px">
        </div>
        <header>
            <el-menu class="el-menu-demo"
                     :default-active="activeIndex"
                     mode="horizontal"
                     background-color="#221814"
                     text-color="#fff"
                     active-text-color="#fabe00">
                <div class="inline">
                    <div class="logo">
                        <el-menu-item class="hove"
                                      index="">
                            <img @click="gohome"
                                 class="login"
                                 src="@/assets/images/logooo.png"
                                 alt="">
                        </el-menu-item>
                    </div>
                    <div class="logo">
                        <el-popover placement="bottom"
                                    title=""
                                    width="350"
                                    v-model="visible"
                                    @show="showfirst"
                                    trigger="click">
                            <div class="city-left">
                                <ul class="citylist">
                                    <li @click="allocation"
                                        style="cursor: pointer;"><i class="el-icon-location"></i>
                                        定位
                                    </li>
                                </ul>
                                <ul class="citylist">
                                    <li @mouseover="changecitybuxian()"
                                        @click="urbationbuxian('不限')">不限</li>
                                </ul>
                                <ul class="citylist"
                                    v-for="(item,index) in options">
                                    <li @mouseover="changecity(index)">
                                        {{item.name}}
                                    </li>
                                </ul>
                            </div>
                            <div class="city-right">
                                <ul class="market"
                                    v-for="(item,index) in optionslist">
                                    <li @click="urbation(item)">
                                        {{item.name}}
                                    </li>
                                </ul>
                            </div>
                            <el-button slot="reference"><i class="el-icon-location"></i> {{cityname |citynamebuxian}} <span class="white">[切换城市]</span></el-button>
                        </el-popover>
                    </div>
                </div>
                <template v-for="(item) in menuTop">
                    <template v-if="item.children">
                        <el-submenu :index="item.id">
                            <el-menu-item slot="title"
                                          :disabled="item.demoFlag==''||item.demoFlag=='/environment'"
                                          @click="handleSelect(item)"
                                          :class="item.demoFlag==''||item.demoFlag=='/environment'?'hoverq':''"
                                          :index="item.id">{{item.name}}</el-menu-item>
                            <!-- <template slot="title"
                                  @click="handleSelect(item)">{{item.name}}</template> -->
                            <template v-for="(items) in item.children">
                                <el-menu-item :index="items.id"
                                              @click="handleSelect(items)">{{items.name}}</el-menu-item>
                            </template>
                        </el-submenu>

                    </template>
                    <template v-else>
                        <el-menu-item @click="handleSelect(item)"
                                      :index="
                                          item.id">{{item.name}}</el-menu-item>
                    </template>
                </template>
                <!-- <el-menu-item index="/homepage">首页</el-menu-item>
            <el-submenu index="2">
                <template slot="title">社会招聘</template>
                <el-menu-item index="/talentrecruitment">中高端人才招聘</el-menu-item>
                <el-menu-item index="/jobdetails">招聘详情</el-menu-item>
            </el-submenu>
            <el-submenu index="3">
                <template slot="title">省区招聘</template>
                <el-menu-item index="/resumezp">个人简历</el-menu-item>
                <el-menu-item index="/selection">选项2</el-menu-item>
            </el-submenu>
            <el-submenu index="4">
                <el-menu-item slot="title"
                              index="/campusRecruitment">校园招聘</el-menu-item>
                <el-menu-item index="/preachingtour">宣讲行程</el-menu-item>
                <el-menu-item index="/preachingDetails">宣讲详情</el-menu-item>
                <el-menu-item index="/resume">校招职位</el-menu-item>
            </el-submenu>
            <el-submenu index="5">
            </el-submenu> -->
                <div class="operation">
                     <p class="nologin">
                     <!--   <a style="display:none;" v-if="!userNameLogin"
                           href="javascript:;"
                           @click="login()">登录</a>
                        <a class="userNameLogin"
                           href="javascript:;"
                           v-if="userNameLogin">{{userNameLogin |colation}}</a>
                        <span style="display:none;">|</span>
                        <a v-if="!userNameLogin"
                           href="javascript:;"
                           style="display:none;"
                           @click="registerClick">注册</a>
                        <a class="tuichu"
                          style="display:none;"
                           v-if="userNameLogin"
                           href="javascript:;"
                           @click="loginOut()">退出</a>-->
                    </p>
                </div>
            </el-menu>
        </header>
    </div>
</template>

<script>
import { queryprovinceandcity } from "@/api/jobPosition";
import { BaiduMap } from "@/map/map.js";
import { selectbyname } from "@/api/apiall.js";
import { mapGetters } from "vuex";
import router from "@/router";
import store from "@/store";
import {
    getUser,
    getUsers,
    logOutUsers,
    queryUserById,
    modifyUserPwd,
    loginOut2
} from "@/api/login";
export default {
    data() {
        return {
            visible: false,
            cityname: "全国",
            options: [],
            optionslist: [],
            selectedOptions: [],
            activeIndex: "B6D6261C-0072-E94C-C1F4-1996A72156FA",
            userName: ""
        };
    },
    computed: {
        ...mapGetters(["menuTop", "userNameLogin"])
    },
    watch: {
        $route(to, from) {
            let active = sessionStorage.getItem("activeIndex");
            this.activeIndex = active;
            if (to.name == "homepage" && from.name == "talentrecruitment") {
                sessionStorage.removeItem("ationcode");
            }
        }
        // userNameLogin: {
        //   handler(newName, oldName) {
        //     this.userName = newName
        //   },
        //   // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法
        //   immediate: true
        // }
    },
    mounted() {
        sessionStorage.setItem("citycode", "");
    },
    created() {
        this.searchcity();
        this.city();
        let active = sessionStorage.getItem("activeIndex");
        this.activeIndex = active;
        //if (sessionStorage.getItem("coustomerView")) {
        // this.getUserInfo();
        //  }
        // if (this.$route.path == "/") {
        //     this.activeIndex = "";
        // }
    },
    methods: {
        // handleSelect(key, keyPath) {
        //     console.log(key, keyPath);
        // },
        login() {
            window.location.href =
                process.env.VUE_APP_CAS +
                "?service=" +
                window.location.href.replace("#", "%23");
        },
        // 注册
        registerClick() {
            window.location.href =
                process.env.VUE_APP_ZCE +
                "?service=" +
                window.location.href.replace("#", "%23");
        },
        gohome() {
            this.$router.push("/");
        },
        //退出登录
        loginOut() {
            const isIE = !!window.ActiveXObject || "ActiveXObject" in window;
            if (isIE) {
                let self = this;
                let iframeEle2 = document.createElement("iframe"); //https://passport-test.yimidida.com/logout?service=https://wwwtest.yimidida.com
                iframeEle2.src = process.env.VUE_APP_API + "/login/loginOut2";
                // debugger
                iframeEle2.style.width = "0px";
                iframeEle2.style.height = "0px";
                iframeEle2.onload = function() {
                    window.sessionStorage.clear();
                    window.sessionStorage.removeItem("userInfoView");
                    store.dispatch("changeUserName", "");
                    loginOut2().then(res => {});
                    router.push("/");
                };
                document.body.appendChild(iframeEle2);
                let iframeEle0 = document.createElement("iframe");
                iframeEle0.src =
                    process.env.VUE_APP_CAS +
                    "/logout?service=" +
                    process.env.VUE_APP_API +
                    "/login/loginOut/success";
                // debugger
                iframeEle0.style.width = "0px";
                iframeEle0.style.height = "0px";
                iframeEle0.onload = function() {
                    window.sessionStorage.clear();
                    window.sessionStorage.removeItem("userInfoView");
                    store.dispatch("changeUserName", "");
                    router.push("/");
                };
                document.body.appendChild(iframeEle0);
                let iframeEle3 = document.createElement("iframe");
                iframeEle3.src =
                    process.env.VUE_APP_API + "/login/loginOut/success";
                // debugger
                iframeEle3.style.width = "0px";
                iframeEle3.style.height = "0px";
                iframeEle3.onload = function() {
                    logOutUsers().then(res => {
                        // alert(res)
                        // document.body.removeChild(iframeEle0);
                        // document.body.removeChild(iframeEle2);
                        // document.body.removeChild(iframeEle3);
                    });
                    window.sessionStorage.clear();
                    window.sessionStorage.removeItem("userInfoView");
                    store.dispatch("changeUserName", "");
                    router.push("/");
                };
                document.body.appendChild(iframeEle3);
            } else {
                loginOut2().then(res => {
                    // if (res) {
                    sessionStorage.clear();
                    this.$store.dispatch("changeUserName", "");
                    this.$router.push("/");
                    // }
                });
            }
        },
        city() {
            if (sessionStorage.getItem("city")) {
                this.cityname = sessionStorage.getItem("city");
                selectbyname({ name: this.cityname }).then(res => {
                    if (res.status == 2000) {
                        sessionStorage.setItem(
                            "citycode",
                            JSON.stringify(res.data.codecitys)
                        );
                    }
                });
            } else {
                this.searchcityallocation();
            }
        },
        searchcityallocation() {
            //实例化城市查询类
            var _this = this;
            var citysearch = new AMap.CitySearch("allmap");
            //自动获取用户IP，返回当前城市
            citysearch.getLocalCity(function(status, result) {
                if (status === "complete" && result.info === "OK") {
                    if (result && result.city && result.bounds) {
                        var cityinfo = result.city;
                        var citybounds = result.bounds;
                        _this.cityname = cityinfo;
                        selectbyname({ name: cityinfo }).then(res => {
                            if (res.status == 2000) {
                                sessionStorage.setItem(
                                    "citycode",
                                    JSON.stringify(res.data.codecitys)
                                );
                            }
                        });
                        sessionStorage.setItem("city", cityinfo);
                    }
                }
            });
        },
        allocation() {
            this.searchcityallocation();
            this.visible = false;
        },
        searchcity() {
            queryprovinceandcity(-1).then(res => {
                this.options = res.data;
            });
        },
        urbation(item) {
            let number = Number(item.parentCode);
            let arr = [number, item.code];
            this.cityname = item.name;
            sessionStorage.setItem("citycode", JSON.stringify(arr));
            sessionStorage.setItem("city", item.name);
            this.visible = false;
        },
        urbationbuxian(item) {
            this.cityname = item;
            sessionStorage.setItem("citycode", "");
            sessionStorage.setItem("city", item);
            sessionStorage.removeItem("estimate");
            this.visible = false;
        },
        changecity(index) {
            console.log(index);
            this.optionslist = this.options[index].child;
        },
        changecitybuxian() {
            this.optionslist = [];
        },

        showfirst() {
            this.optionslist = this.options[0].child;
        },
        handleChange() {},
        handleSelect(item) {
            sessionStorage.setItem("pageindex", 1);
            sessionStorage.setItem("pagesize", 6);
            sessionStorage.removeItem("ruleForm");
            sessionStorage.removeItem("ationcode");
            sessionStorage.removeItem("positionType");
            if (item.name == "首页") {
                this.$router.push("/");
                return;
            } else if (
                item.name == "账号设置" ||
                item.name == "我的简历" ||
                item.name == "职位收藏" ||
                item.name == "投递记录"
            ) {
                let islogin = sessionStorage.getItem("userNameLogin");
                if (
                    islogin == null ||
                    islogin == "" ||
                    islogin == "undefined"
                ) {
                    window.location.href =
                        process.env.VUE_APP_CAS +
                        "?service=" +
                        window.location.href.replace("#", "%23") +
                        item.demoFlag.replace("/", "") +
                        "?id=" +
                        item.id;
                    return;
                }
            }
            if (item.opennew !== "1") {
                let idflag = item.id;
                //增加跳转别菜单的判断
                if (item.urlMenu == "4") {
                    window.open(item.demoFlag, "_self");
                }
                if (item.urlMenu === "3") {
                    let array = item.parentIds.split(",");
                    idflag = array[array.length - 1];
                }
                // this.$store.dispatch("ParentList", "");
                if (item.name == "首页") {
                    this.$router.push({
                        path: item.demoFlag
                    });
                } else {
                    this.$router.push({
                        path: item.demoFlag,
                        query: {
                            id: idflag
                        }
                    });
                }
                // this.$store.dispatch("ParentList", "");
                // this.$store.dispatch("UpdateActive", item);
            } else {
                this.$store.dispatch("UpdateActive", item);
            }
        }
    },
    beforeDestroy() {
        document.body.removeChild(iframeEle);
        document.body.removeChild(iframeEle2);
    }
};
</script>
<style scoped lang="scss">
.el-cascader {
    width: 70px;
    background-color: rgba($color: #000000, $alpha: 0) !important;
    /deep/ .el-input__inner {
        color: #fabe00 !important;
        background-color: rgba($color: #000000, $alpha: 0) !important;
        padding: 0;
    }
    /deep/ .el-cascader__label {
        padding: 0 0 0 3px;
        color: #fabe00;
    }
}
/deep/ .el-icon-arrow-down {
    display: none !important;
}
.el-button {
    margin-left: -14px;
    border: none;
    color: #fabe00;
    line-height: 60px;
    font-size: 15px;
    background-color: rgba($color: #000000, $alpha: 0) !important;
    padding: 0 10px;
}
.el-button:hover {
    background-color: rgba($color: #000000, $alpha: 0) !important;
}
.theHeader {
    position: relative;
    height: 60px;
    background-color: #221814;
    overflow: hidden;
    z-index: 99;
    header {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;

        .lists {
            position: absolute;
        }
        .el-menu {
            width: 500px;
            z-index: 99;
            .inline {
                // width: 320px;
                // float: left;
                .logo {
                    float: left;
                    // width: 120px;
                    margin-right: 10px;
                    .el-menu-item {
                        margin-left: -20px;
                    }
                    .el-menu-item:hover {
                        background-color: #221814 !important;
                    }
                    .login {
                        z-index: 99;
                        cursor: pointer;
                        width: 121px;
                        margin-top: 9px;
                        display: block;
                    }
                }
                .logo:focus {
                    outline: none;
                }
                .white {
                    color: #ddd;
                    font-size: 12px;
                    line-height: 60px;
                }
                .white:hover {
                    color: #fff;
                }
                .allocation {
                    cursor: pointer;
                    color: #fabe00;
                    line-height: 60px;
                    margin: 0 0 0 20px;
                }
                span {
                    .button {
                        display: block;
                    }
                }
            }
            .el-icon-arrow-down {
                display: none;
            }
            .hoverq {
                cursor: text;
                opacity: 1;
            }
            .operation {
                float: right;
                .nologin {
                    font-size: 15px;
                    line-height: 60px;
                    color: #fff;
                    a {
                        // width: 30px;
                        text-decoration: none;
                        color: #fff;
                        float: left;
                        margin: 0 10px;
                        &:hover {
                            color: #fabe00;
                        }
                    }
                    .tuichu {
                        margin-right: 0px;
                    }
                    span {
                        // width: 30px;
                        float: left;
                        margin: 0 10px;
                    }
                    .userNameLogin:hover {
                        color: #fff;
                    }
                }
            }
            .operation:focus {
                outline: none;
            }
        }
    }
}
</style>
